import { Box } from '@mui/material'; // import Box for layout
import { EmailAuthProvider, GoogleAuthProvider } from 'firebase/auth';
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { auth } from '../../firebase/firebaseAuth';
import { HelpTextComponent } from '../base/helpText/HelpTextComponent';
import { Loading } from '../base/loading/Loading';
import { AnimatedBox, SpeedDurations } from '../MotionMui/MotionMui'; // Adjust path if needed
import './SignIn.css'; // Keep for existing Firebase UI styles or other base styles
import StyledFirebaseAuth from './StyledFirebaseAuth';

// Note: As requested, styles previously in .dugouts-title and .signin-image
// are now applied inline using the 'sx' prop below.

export const SignIn = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // --- FirebaseUI config ---
  const uiConfig = {
    signInFlow: 'popup',
    signInOptions: [
      EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD,
      GoogleAuthProvider.PROVIDER_ID,
    ],
    callbacks: {
      signInSuccessWithAuthResult: () => {
        console.log('signInSuccessWithAuthResult callback fired.');
        // Manually redirect the user to the /teams/ page.
        history.push('/teams/');

        // Return false to prevent FirebaseUI from trying to redirect (the deprecated behavior).
        return false;
      },
      uiShown: function () {
        // This can still be useful to hide a loader specific to the widget itself,
        // but the main page loader is handled by the onAuthStateChanged listener.
        console.log('FirebaseUI widget shown.');
        setIsLoading(false);
      },
    },
  };

  const handleUserChange = useCallback(
    (user) => {
      if (user) {
        console.log(
          `[${new Date().toISOString()}] new auth observer detected user, pushing to /teams/`
        );
        history.push('/teams/');
      } else {
        console.log(
          `[${new Date().toISOString()}] auth observer detected no user`
        );
      }
    },
    [history]
  );

  useEffect(() => {
    console.log('SignIn: Setting up auth listener...');
    const unregisterAuthObserver = auth.onAuthStateChanged(handleUserChange);

    //Might not be necessary, but trying to protect against race condition where the user might be set at the start but onAuthStateChanged doesn't trigger
    //Unsure of onAuthStateChanged behaviour
    handleUserChange(auth.currentUser);

    return () => {
      console.log('SignIn: Cleaning up auth listener.');
      unregisterAuthObserver();
    };
  }, [handleUserChange]);

  console.log('SignIn: Rendering Animated Sign-In UI.');
  return (
    <AnimatedBox
      root
      staggerSpeed={'Slow'}
      sx={{
        backgroundColor: '#000000',
        height: '100vh',
        width: '100%',
        display: 'flex', // Using flex to help center PageContainerComponent
        flexDirection: 'column',
        alignItems: 'center', // Center horizontally
        justifyContent: 'center', // Center vertically (optional)
      }}
    >
      {isLoading && <Loading />}
      <AnimatedBox>
        <Box
          component="img"
          src="/images/logos/dndlogo.png" // Updated logo path
          alt="Dugouts and Dragons Logo"
          sx={{
            display: 'flex',
            justifyContent: 'center',
            // Styles previously in .signin-image
            width: '50vmin', // Adjust size as needed
            height: '50vmin',
            //  flexGrow: 1,
            flexShrink: 2,
          }}
        />
      </AnimatedBox>
      <AnimatedBox transition={{ duration: SpeedDurations.Slow, delay: 5 }}>
        <HelpTextComponent>
          Please sign in to manage your team
        </HelpTextComponent>
      </AnimatedBox>
      <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={auth} />
    </AnimatedBox>
  );
};
